import { Navigate, RouteObject } from 'react-router-dom';

import { UserModel } from '@/models/UserModel';
import ProfilePage from '@/pages/ProfilePage';
import ProfilePageGeneralInfo from '@/pages/ProfilePage/ProfilePageGeneralInfo';

import { RoutePath } from '../RoutePath';

import { getCRMBedboardRoutes } from './getCrmBedboardRoutes';
import { getCrmReferralOutboundRoutes } from './getCrmReferralOutboundRoutes';
import { getCrmScreenerResidentsRoutes } from './getCrmScreenerResidentsRoutes';
import { getCrmScreenerRoutes } from './getCrmScreenerRoutes';
import { getCrmSourcesRoutes } from './getCrmSourcesRoutes';
import { getCrmTasksRoutes } from './getCrmTasksRoutes';
import { getCrmWaitlistRoutes } from './getCrmWaitlistRoutes';

export const getCrmRoutes = (currentUser: UserModel): RouteObject[] => {
  const catchAllRoute = currentUser.isScreenerCustomer()
    ? RoutePath.CRMScreenerAllLeads
    : '/';

  return [
    {
      path: RoutePath.Profile,
      element: <ProfilePage />,
      children: [
        {
          index: true,
          element: <ProfilePageGeneralInfo />
        }
      ]
    },
    ...getCrmTasksRoutes(),
    ...getCrmScreenerRoutes(),
    ...getCrmScreenerResidentsRoutes(),
    ...getCrmSourcesRoutes(),
    ...getCrmWaitlistRoutes(),
    ...getCRMBedboardRoutes(),
    ...getCrmReferralOutboundRoutes(),
    // Catch-all route
    {
      path: '/*',
      element: <Navigate to={catchAllRoute} replace />
    }
  ];
};
